<template>
    <TotemTag
        :name="selectedContentType.label"
        size="small"
        @handleClick="$emit('handleClick')"
        v-if="selectedContentType"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                selectedContentType: 'CourseFilter/getSelectedContentType'
            })
        }
    }
</script>
